import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";

import i18n from "i18n-react";

import "react-toastify/dist/ReactToastify.css";

import ReactCrop from "react-image-crop";

import "react-image-crop/lib/ReactCrop.scss";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { APIHandler, StorageHandler } from "C4";
import { storageKeys } from "settings";

import SweetAlert from "sweetalert-react";
import "assets/styles/sweetalert.css";

const REDIRECT_URL = "/count-down";

export default class ProfileImageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: null,
      crop: {
        unit: "%",
        aspect: 10 / 10,
        width: 50,
      },
      loading: false,
      redirect: "",
      profile_image: "",
      popup: false,
    };

    this.uploadFile = this.uploadFile.bind(this);
    this.resetUpload = this.resetUpload.bind(this);
  }

  getProfileImage() {
    StorageHandler.load(storageKeys.accessToken).then((res) => {
      if (res) {
        console.log(res);
        APIHandler.getProfileInfo(10, res).then((response) => {
          if (response) {
            this.setState({ profile_image: response.response.profile_image });
          }
        });
      }
    });
  }

  onSelectFile = (e) => {
    const fileSize = e.target.files[0].size / 1024 / 1024;
    if (fileSize > 10) {
      this.setState({
        popup: true,
      });
      return;
    }
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async uploadFile() {
    this.setState({ loading: true });
    const { src } = this.state;
    StorageHandler.load(storageKeys.accessToken).then((token) => {
      APIHandler.uploadProfile(token, src).then((completed) => {
        if (completed) {
          this.setState({ loading: false });
          this.setState({ redirect: REDIRECT_URL });
        }
      });
    });
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          // reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  resetUpload() {
    this.setState({
      src: null,
      profile_image: "",
    });
  }

  componentDidMount() {
    this.getProfileImage();
  }

  render() {
    const { crop, src, redirect, loading, profile_image, popup } = this.state;
    const close = () => {
      this.setState({
        popup: false,
      });
    };

    return (
      <div className="profileImageHolder">
        <div className="gradient" />
        <div className="bg" />

        <div className="profileHolder">
          {profile_image && (
            <React.Fragment>
              <div className="title">
                <span>Your current profile image:</span>
                <img
                  src={`https://profileimagestravpro.imgix.net/${encodeURIComponent(profile_image)}?q=50&auto=format&w=500&h=auto`}
                  alt="profile-img"
                  className="profile-img"
                />
                <div className="buttonHolder">
                  <button className="upload" onClick={this.resetUpload}>
                    Upload another image
                  </button>
                  <Link to="/count-down">
                    <button className="showFloor">Go back to count down page &gt;</button>
                  </Link>
                </div>
              </div>
            </React.Fragment>
          )}
          {!profile_image && (
            <React.Fragment>
              <div className="title">
                <span>Upload your profile image:</span>
              </div>
              {!src && (
                <div className="uploader">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.onSelectFile}
                    className="inputfile inputfile-4"
                    name="file"
                    id="file"
                  />
                  <label htmlFor="file">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="17"
                        viewBox="0 0 20 17"
                      >
                        <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
                      </svg>
                    </figure>{" "}
                    <span>Choose a file…</span>
                  </label>
                  <Link to={REDIRECT_URL}>
                    <button className="skip">Or skip this step &gt;</button>
                  </Link>
                </div>
              )}
              {src && (
                <React.Fragment>
                  <div className="cropHolder">
                    <ReactCrop
                      src={src}
                      crop={crop}
                      onImageLoaded={this.onImageLoaded}
                      onComplete={this.onCropComplete}
                      onChange={this.onCropChange}
                      circularCrop="true"
                    />
                  </div>
                  <div className="buttonHolder">
                    <button className="upload" onClick={this.resetUpload}>
                      Upload another file
                    </button>
                    <button onClick={this.uploadFile}>
                      {loading ? (
                        <span>
                          <FontAwesomeIcon
                            icon={["fas", "circle-notch"]}
                            spin
                          />
                        </span>
                      ) : (
                        <span>
                          <FontAwesomeIcon icon={["far", "upload"]} />
                          Save this profile image
                        </span>
                      )}
                    </button>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          <SweetAlert
            title="Uploading size exceeded"
            show={popup}
            html
            type="warning"
            text="Max image upload size is 10mb"
            customClass="noAgent"
            showConfirmButton={false}
            cancelButtonText={i18n.translate("general.close")}
            showCancelButton
            onConfirm={close}
            onCancel={close}
            onEscapeKey={close}
            onOutsideClick={close}
          />
        </div>
        {redirect.length > 0 && <Redirect push to={redirect} />}
      </div>
    );
  }
}
